import { createRoute, lazyRouteComponent } from "@tanstack/react-router";
import { NotificationSidebarAction } from "@modules/notifications/components/NotificationSidebarAction";

const NotificationsPage = lazyRouteComponent(() => import("@modules/notifications/pages/NotificationsPage"), "NotificationsPage");

export function getRoutes(parentRoute) {
  return [createRoute({ getParentRoute: () => parentRoute, path: "/notifications", component: NotificationsPage })];
}

export function getSidebarAction() {
  return NotificationSidebarAction;
}
